import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const FileIcon = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg width={19} height={21} viewBox="0 0 19 21" fill="none" {...props}>
          <Path
            d="M5.78125 1H13.7812C15.4359 1 16.5358 1.46994 17.2275 2.21484C17.9255 2.96652 18.2812 4.07665 18.2812 5.5V15.5C18.2812 16.9234 17.9255 18.0335 17.2275 18.7852C16.5358 19.5301 15.4359 20 13.7812 20H5.78125C4.12663 20 3.02672 19.5301 2.33496 18.7852C1.63697 18.0335 1.28125 16.9234 1.28125 15.5V5.5C1.28125 4.07665 1.63697 2.96652 2.33496 2.21484C3.02672 1.46994 4.12663 1 5.78125 1ZM5.78125 14.25C5.09511 14.25 4.53125 14.8139 4.53125 15.5C4.53125 16.1861 5.09511 16.75 5.78125 16.75H13.7812C14.4674 16.75 15.0312 16.1861 15.0312 15.5C15.0312 14.8139 14.4674 14.25 13.7812 14.25H5.78125ZM5.78125 10.25C5.09511 10.25 4.53125 10.8139 4.53125 11.5C4.53125 12.1861 5.09511 12.75 5.78125 12.75H9.78125C10.4674 12.75 11.0312 12.1861 11.0312 11.5C11.0312 10.8139 10.4674 10.25 9.78125 10.25H5.78125ZM12.2812 1.75C11.5951 1.75 11.0312 2.31386 11.0312 3V5C11.0312 6.79614 12.4851 8.25 14.2812 8.25H16.2812C16.9674 8.25 17.5312 7.68614 17.5312 7C17.5312 6.31386 16.9674 5.75 16.2812 5.75H14.2812C13.8674 5.75 13.5312 5.41386 13.5312 5V3C13.5312 2.31386 12.9674 1.75 12.2812 1.75Z"
            fill={props.color || '#E08500'}
            stroke={props.color || '#E08500'}
          />
        </Svg>
      </View>
    );
  },
);

export { FileIcon };
